import { AppState } from './app-state';

export const appSelector = (state: AppState): AppState => state;
